import NextImage from 'next/image'
import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'

export const Wrapper = styled.div`
  ${tw`px-insetX grid grid-cols-1 ta-max-width`};
  grid-template-rows: min-content min-content;
`

export const BackLink = styled.a`
  ${tw`inline-block whitespace-nowrap`};
  color: var(--color-gold);
  cursor: pointer;

  @media (min-width: 80rem) {
    ${tw`absolute top-7 left-8`};
    max-width: none;
  }

  svg {
    ${tw`inline-block mr-1`};
    width: 7px;
    height: 9px;
    margin-top: -0.2rem;
  }
`

export const Root = styled.div`
  ${tw`p-8 -mt-6 lg:-mt-12 mx-6 lg:mx-12 flex flex-wrap relative z-10`};
  background-color: var(--color-gold-white);
`

export const RootInner = styled.div`
  ${tw`grid grid-cols-1 gap-6 mx-auto`};
  max-width: ${rem(650)};
`

export const Main = styled.div`
  order: -1;
`

export const Summary = styled.div`
  color: var(--color-blue-grey);
`

export const Image = styled(NextImage)`
  ${tw`block w-full`};
`
